import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Mail, CheckCircle2, XCircle } from "lucide-react";

export default function AdminEmailLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/email-log").then((r) => setRows(r.data)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400">Administrator</div>
      <h1 className="mt-2 text-4xl font-bold tracking-tight flex items-center gap-3">
        <Mail className="w-8 h-8 text-cyan-400" /> Email Log
      </h1>
      <p className="mt-2 text-zinc-500 text-sm">Audit log of transactional emails sent from SonotekDigi.</p>

      <div className="mt-8 rounded-2xl border border-zinc-800 bg-zinc-950/60 overflow-x-auto">
        <table className="w-full min-w-[800px]">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-zinc-500 border-b border-zinc-800">
              <th className="p-4">Date/Time</th>
              <th className="p-4">Event</th>
              <th className="p-4">Request ID</th>
              <th className="p-4">Recipient</th>
              <th className="p-4">Status</th>
              <th className="p-4">Detail</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`email-log-${r.id}`} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="p-4 text-zinc-400 text-sm">{new Date(r.created_at).toLocaleString()}</td>
                <td className="p-4 text-xs font-mono text-cyan-400">{r.event_type}</td>
                <td className="p-4 text-xs font-mono">{r.request_id || "—"}</td>
                <td className="p-4 text-sm text-zinc-300">{r.recipient}</td>
                <td className="p-4">
                  {r.status === "Sent" ? (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs">
                      <CheckCircle2 className="w-3 h-3" /> Sent
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-rose-500/10 border border-rose-500/30 text-rose-400 text-xs">
                      <XCircle className="w-3 h-3" /> Failed
                    </span>
                  )}
                </td>
                <td className="p-4 text-xs text-zinc-500 max-w-md truncate" title={r.detail}>{r.detail || "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="6" className="p-12 text-center text-zinc-500">No email events yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
